import { type QueryFunction } from "@tanstack/react-query";
import {
  type AuthTransport,
  type UnauthorizedBehavior,
  createApiRequest,
  createQueryFn,
  createQueryClient,
} from "@scroll/shared-query";

// Web transport uses cookie-based auth (credentials: "include")
const webTransport: AuthTransport = {
  getHeaders: async () => ({}),
  getBaseUrl: () => "",
  getFetchOptions: () => ({ credentials: "include" as const }),
};

export const apiRequest = createApiRequest(webTransport);

export const getQueryFn: <T>(options: {
  on401: UnauthorizedBehavior;
}) => QueryFunction<T> = ({ on401 }) => createQueryFn(webTransport, { on401 });

export const queryClient = createQueryClient(
  getQueryFn({ on401: "throw" }),
);
